import useNetwork from './network';
import { IInsurerModel } from './models/insurerModel';

export const fetchInsurer = async (lang: string) => {
    const { fetchInsurer } = useNetwork();
    const result = await fetchInsurer(lang);

    if (result.status === 200) {
        return (await result.json()) as IInsurerModel[];
    }
};
